import Swiper, { A11y, Keyboard, Navigation } from 'swiper';

import '../../sass/blocks/blog.scss';

( () => {
    const $blogs = document.querySelectorAll('.blog');

    if ( !$blogs ) return;

    $blogs.forEach( $blog => {
        const $sliders = $blog.querySelectorAll('.blog-category-desktop__slider');

        const initSliders = () => {
            if ( !$sliders ) return;

            $sliders.forEach( $slider => {
                const $previous = $slider.querySelector('.blog-category-desktop__slider-previous');
                const $next = $slider.querySelector('.blog-category-desktop__slider-next');

                const slider = new Swiper($slider, {
                    modules: [ A11y, Keyboard, Navigation ],
                    a11y: {},
                    slidesPerView: 1,
                    allowTouchMove: false,
                    breakpoints: {
                        560: {
                            slidesPerView: 2,
                            slidesPerGroup: 2
                        },
                        768: {
                            slidesPerView: 3,
                            slidesPerGroup: 3
                        }
                    },
                    keyboard: {
                        enabled: true,
                        onlyInViewport: false
                    },
                    navigation: $next && $previous ? {
                        nextEl: $next,
                        prevEl: $previous
                    } : false
                });
            } );
        };

        initSliders();
    } );
} )();
